import React, { createContext, useState, ReactNode, useContext } from "react";

type UserNameContextType = {
	userName: string;
	setUserName: React.Dispatch<React.SetStateAction<string>>;
};

export const UserNameContext = createContext<UserNameContextType | null>(null);

type UserNameProviderProps = {
	children: ReactNode;
};

export const UserNameProvider = ({ children }: UserNameProviderProps) => {
	const [userName, setUserName] = useState(
		localStorage.getItem("firstName") || ""
	);

	return (
		<UserNameContext.Provider value={{ userName, setUserName }}>
			{children}
		</UserNameContext.Provider>
	);
};

const useUserName = () => {
	const context = useContext(UserNameContext);
	if (!context) {
		throw new Error("useBreadCrumb must be used within a BreadCrumbProvider");
	}
	return context;
};

export default useUserName;
